import React from 'react';

//Styles
import styles from "../DashboardFileManagement.module.css"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";
// Autoplay, 

// sliderInfo
// https://codesandbox.io/s/z2s44x?file=/src/styles.css:228-795
// https://swiperjs.com/get-started
// https://swiperjs.com/demos

// import img1 from "../../../../assets/img/1.jpg"
// import img2 from "../../../../assets/img/2.jpg"
// import img3 from "../../../../assets/img/3.jpg"

const CardSlider = (props) => {
    return (
        <>
            <style type="text/css">
                {`
        .swiper {
            width: ${props.wFull ? "100%" : "1074px"};
            height: 467px;
        }

        @media only screen and (max-width: 605.98px) {
            .swiper {
                height: auto;
            }
          }

        `}
            </style>

            {
                props.images != "" ?
                    <div
                        className={`container-fluid w-100 d-flex justify-content-center flex-wrap align-items-center mt-md-3 mt-1 mb-md-3 mb-1 ${props.p_0 ? "p-0" : "px-2"}`}
                        dir="rtl"
                    >
                        <Swiper
                            className="mySwiper"
                            dir='ltr'
                            pagination={{
                                type: "fraction",
                            }}
                            modules={[Pagination, Navigation]}
                            navigation={true}
                            slidesPerView={1}
                            spaceBetween={0}
                            style={{ alignItems: "center" }}
                        >
                            <SwiperSlide>
                                <div className='w-100'>
                                    <img className={styles.slider_img} loading="lazy" src={`https://backdev.azrmelk.com${props.image}`} alt="img" />
                                </div>
                            </SwiperSlide>
                            {props.images?.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <div className='w-100'>
                                        <img className={styles.slider_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageFileUrl}`} alt="img" />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    :
                    <div
                        className={`container-fluid w-100 d-flex justify-content-center flex-wrap align-items-center mt-md-3 mt-1 mb-md-3 mb-1 ${props.p_0 ? "p-0" : "px-2"}`}
                        dir="rtl"
                    >
                        <Swiper
                            className="mySwiper"
                            dir='ltr'
                            pagination={{
                                type: "fraction",
                            }}
                            modules={[Pagination, Navigation]}
                            navigation={true}
                            slidesPerView={1}
                            spaceBetween={0}
                            style={{ alignItems: "center" }}
                        >
                            <SwiperSlide>
                                <div className='w-100'>
                                    <img className={styles.slider_img} loading="lazy" src={`https://backdev.azrmelk.com${props.image}`} alt="img" />
                                </div>
                            </SwiperSlide>
                            {props.images?.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <div className='w-100'>
                                        <img className={styles.slider_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageFileUrl}`} alt="img" />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
            }
        </>
    );
};

export default CardSlider;